import Config from "../../../Configs";
import { ApiResponse, HomePageDataResponse, RegistrationDataResponse, ShareResponse } from "../../../Models";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";

export default class UtilsApiService extends ApiServiceBase {
    constructor(client: IHttpService) {
        super(client);
    }

    async registrationData(): Promise<ApiResponse<RegistrationDataResponse>> {
        return await this._client.get<RegistrationDataResponse>(Config.apiPaths.registrationData);
    }

    async homePageData(): Promise<ApiResponse<HomePageDataResponse>> {
        return await this._client.get<HomePageDataResponse>(Config.apiPaths.homePageData);
    }
    async share(savedItemId: number | null, type: number): Promise<ApiResponse<ShareResponse>> {
        const id = savedItemId ? savedItemId : 0;
        return await this._client.get<ShareResponse>(Config.apiPaths.share.replace("{0}", id.toString()).replace("{1}", type.toString()));
    }
}
